import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const Network = (): unknown => {
    return import(/* webpackPrefetch: true */ './network-page.vue');
};

export const networkRoute: RouteRecordRaw = {
    ...ROUTE_DATA.NETWORK_PAGE,
    components: {
        main: Network
    }
};
